import { useState } from "react";

export default function NewsletterSubscription({
  resourcedTexts,
  newsletterPreferencesData,
  isLoggedIn,
}) {
  const hasTopics = newsletterPreferencesData.preferences.length > 0;
  let firstHalf, secondHalf;
  const [receiveNewsletter, setReceiveNewsletter] = useState(
    newsletterPreferencesData.receiveNewsletters
  );
  const [preferences, setPreferences] = useState(
    newsletterPreferencesData.preferences
  );
  const [serverError, setServerError] = useState('');

  if (hasTopics) {
    const middleIndex = Math.ceil(preferences.length / 2);
    firstHalf = preferences.slice(0, middleIndex);
    secondHalf = preferences.slice(middleIndex);
  }

  function handleNewsletterToggleChange(value) {
    value
      ? window.dataLayer.push({ event: "subscribe_newsletter" })
      : window.dataLayer.push({ event: "unsubscribe_newsletter" });

    setReceiveNewsletter(value);

    if (isLoggedIn) {
      let endpoint = value
        ? newsletterPreferencesData.addNewsletterSubscriptionApiUrl
        : newsletterPreferencesData.removeNewsletterSubscriptionApiUrl;

      fetch(endpoint, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          RequestVerificationToken:
            newsletterPreferencesData.requestVerificationToken,
        },
      });
    }
  }

  function handleToggleChange(name) {
    const updatedItem = preferences.find((item) => item.name === name);
    const updated = preferences.map((item) =>
      item.name === name ? { ...item, isChecked: !item.isChecked } : item
    );

    updatedItem.isChecked
      ? window.dataLayer.push({
          event: "add_interest",
          subject: updatedItem.name,
        })
      : window.dataLayer.push({
          event: "remove_interest",
          subject: updatedItem.name,
        });

    setPreferences(updated);

    if (isLoggedIn) {
      fetch(newsletterPreferencesData.changeNewsletterInterestApiUrl, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          RequestVerificationToken:
            newsletterPreferencesData.requestVerificationToken,
        },
        body: JSON.stringify({
          interests: updated,
        }),
      });
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    fetch(newsletterPreferencesData.submitNewsletterPreferencesApiUrl, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        RequestVerificationToken:
          newsletterPreferencesData.requestVerificationToken,
      },
      body: JSON.stringify({
        subscribed: receiveNewsletter,
        email: newsletterPreferencesData.email,
        firstName: newsletterPreferencesData.firstName,
        interests: preferences,
      }),
    }).then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          var json = await response.json();

          if (json.success)
          {
            receiveNewsletter
              ? (window.location.href = newsletterPreferencesData.subscribePage)
              : (window.location.href = newsletterPreferencesData.unsubscribePage);
          }
          else 
          {
            setServerError(resourcedTexts.serverError);
          }
        }
    })

  }

  function getToggleBlock(index, title, value) {
    return (
      <li key={index} className="newsletter-preferences__toggle-block">
        <h4 className="newsletter-preferences__toggle-title">{title}</h4>
        <label className="newsletter-preferences__toggle">
          <input
            type="checkbox"
            checked={value}
            onChange={() => handleToggleChange(title)}
          />
          <span
            className="newsletter-preferences__toggle-slider"
            data-yes={resourcedTexts.toggleYes}
            data-no={resourcedTexts.toggleNo}
          ></span>
        </label>
      </li>
    );
  }

  return (
    <section className="grid-container newsletter-preferences">
      <form className="newsletter-preferences__layout" onSubmit={handleSubmit}>
        <div className="newsletter-preferences__block">
          <h2 className="newsletter-preferences__title">
            {resourcedTexts.titleNewsletterPreferences}
          </h2>
          <div className="newsletter-preferences__divider"></div>
          <div className="newsletter-preferences__content">
            {!isLoggedIn && (
              <div>
                <h3 className="newsletter-preferences__sub-title">
                  {resourcedTexts.titleContactInfo}
                </h3>
                <div className="newsletter-preferences__row">
                  <div>
                    <label htmlFor="firstNameTwo">
                      {resourcedTexts.labelFirstName}
                    </label>
                    <input
                      id="firstNameTwo"
                      type="text"
                      autoComplete="given-name"
                      value={newsletterPreferencesData.firstName}
                      required
                      disabled
                    />
                  </div>
                  <div>
                    <label htmlFor="emailTwo">
                      {resourcedTexts.labelEmail}
                    </label>
                    <input
                      id="emailTwo"
                      type="email"
                      autoComplete="email"
                      value={newsletterPreferencesData.email}
                      required
                      disabled
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="newsletter-preferences__toggle-main">
              <div className="newsletter-preferences__toggle-block">
                <h4 className="newsletter-preferences__toggle-title">
                  {resourcedTexts.labelNewsletter}
                </h4>
                <label className="newsletter-preferences__toggle">
                  <input
                    type="checkbox"
                    checked={receiveNewsletter}
                    onChange={(e) =>
                      handleNewsletterToggleChange(e.target.checked)
                    }
                  />
                  <span
                    className="newsletter-preferences__toggle-slider"
                    data-yes={resourcedTexts.toggleYes}
                    data-no={resourcedTexts.toggleNo}
                  ></span>
                </label>
              </div>
              <div className="newsletter-preferences__toggle-block">
                <p>{resourcedTexts.descriptionNewsletter}</p>
              </div>
            </div>

            {receiveNewsletter && hasTopics && (
              <>
                <div className="newsletter-preferences__divider"></div>
                <div>
                  <h3 className="newsletter-preferences__sub-title">
                    {resourcedTexts.titleNewsletterSubjects}
                  </h3>
                  <div className="newsletter-preferences__toggle-groups">
                    <ul className="newsletter-preferences__toggle-group">
                      {firstHalf.map((item, index) =>
                        getToggleBlock(index, item.name, item.isChecked)
                      )}
                    </ul>

                    <ul className="newsletter-preferences__toggle-group">
                      {secondHalf.map((item, index) =>
                        getToggleBlock(index, item.name, item.isChecked)
                      )}
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {isLoggedIn && (
          <div className="newsletter-preferences__block">
            <h2 className="newsletter-preferences__title">
              {resourcedTexts.titleContactInfo}
            </h2>
            <div className="newsletter-preferences__divider"></div>
            <div>
              <p>{resourcedTexts.descriptionContactInfo}</p>
              <div className="newsletter-preferences__row">
                <div className="newsletter-preferences__info">
                  <span>{resourcedTexts.labelFirstName}</span>
                  <span>{newsletterPreferencesData.firstName}</span>
                </div>
                <div className="newsletter-preferences__info">
                  <span>{resourcedTexts.labelEmail}</span>
                  <span>{newsletterPreferencesData.email}</span>
                </div>
              </div>
              <a
                className="link-forward"
                href={newsletterPreferencesData.editAccountUrl}
              >
                {resourcedTexts.editEmail}
              </a>
            </div>
          </div>
        )}

        {!isLoggedIn && (
          <button type="submit" className="newsletter-preferences__submit">
            {resourcedTexts.submit}
          </button>
        )}
      </form>

      
      {serverError && (
        <div class="callout callout--error" data-closable>
            <p>
                {serverError}
            </p>
            <button class="close-button" aria-label="Dismiss alert" type="button" data-close>
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
      )}
    </section>
  );
}
